import React from 'react';
import PropTypes from 'prop-types';

// Components
import NoTicketsForFilter from './components/react-no-tickets-for-filter';

import './NoListingsFilterView.scss';

const NoListingsFilterView = ({onResetFilter, className = ''}) => (
  <div className={`NoListingsFilterView ${className}`}>
    <NoTicketsForFilter onResetFiltersClick={onResetFilter} />
  </div>
);

NoListingsFilterView.propTypes = {
  /**
   * Method to reset filters
   */
  onResetFilter: PropTypes.func,

  /**
   * The Class Name used to override the Styling for the component.
   */
  className: PropTypes.string,
};

export default NoListingsFilterView;
